import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Medkit = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="medkit icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8566 18.2083C17.5302 18.2083 12.4019 23.3366 12.4019 29.663C12.4019 35.9894 17.5302 41.1196 23.8566 41.1196C30.183 41.1196 35.3113 35.9894 35.3113 29.663C35.3113 23.3366 30.183 18.2083 23.8566 18.2083ZM23.8566 21.0883C28.5836 21.0883 32.4313 24.9341 32.4313 29.663C32.4313 34.392 28.5836 38.2397 23.8566 38.2397C19.1296 38.2397 15.2819 34.392 15.2819 29.663C15.2819 24.9341 19.1296 21.0883 23.8566 21.0883ZM29.6156 28.2227H25.2975V23.9027H22.4156V28.2227H18.0956V31.1027H22.4156V35.4227H25.2975V31.1027H29.6156V28.2227ZM45.12 43.8509C45.12 44.5382 44.5382 45.12 43.8509 45.12H4.14912C3.46176 45.12 2.88 44.5382 2.88 43.8509V15.4771C2.88 14.7878 3.46176 14.208 4.14912 14.208H43.8509C44.5382 14.208 45.12 14.7878 45.12 15.4771V43.8509ZM14.88 7.84894C14.88 5.1091 17.1571 2.87998 19.9546 2.87998H28.0435C30.8429 2.87998 33.12 5.1091 33.12 7.84894V11.328H14.88V7.84894ZM43.8509 11.328H36V7.84896C36 3.52128 32.4326 0 28.0435 0L19.9546 0C15.5674 0 12 3.52128 12 7.84896V11.328H4.14912C1.86816 11.328 0 13.1942 0 15.4771L0 43.8509C0 46.1318 1.86816 48 4.14912 48H43.8509C46.1318 48 48 46.1318 48 43.8509V15.4771C48 13.1942 46.1318 11.328 43.8509 11.328Z"
    />
  </svg>
)
